export default __webpack_public_path__ + "static/media/nftlogoSvg.bbef73d8.svg";